module.exports = __webpack_public_path__ + "img/36.5410bd52.jpg";